import React from 'react';
import Button from '@mui/material/Button';

interface Props {
  onClick: () => void;
  danger?: boolean;
  text: string;
}

const SubmitButton: React.FC<Props> = ({ onClick, text }) => {
  return (
    <Button
      onClick={onClick}
      sx={(theme) => ({
        textTransform: 'initial',
        '&:hover': {
          backgroundColor: theme.palette.altSurfaceHover.main,
        },
      })}
      fullWidth
      color="altSurface"
    >
      {text}
    </Button>
  );
};

export default React.memo(SubmitButton);
